import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

/**
 * The model gateway, from the deployment's side.
 *
 * What we asked and what it charged, what we are willing to call, and the
 * wordings we ask through. Three questions with one vendor behind them, which
 * is the whole reason there is a gateway rather than three SDKs.
 *
 * Pathless, so a single run or a single prompt stays out of it.
 */
export const Route = createFileRoute('/_app/admin/ai/_list')({
  component: AiLayout,
})

const SECTIONS = [
  { to: '/admin/ai', leaf: 'ai', label: 'Runs' },
  { to: '/admin/ai/models', leaf: 'models', label: 'Models' },
  { to: '/admin/ai/prompts', leaf: 'prompts', label: 'Prompts' },
] as const

function AiLayout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const leaf = pathname.replace(/\/$/, '').split('/').filter(Boolean).at(-1) ?? 'ai'

  return (
    <>
      <nav className="mb-4 flex flex-wrap gap-1">
        {SECTIONS.map((section) => (
          <Link
            key={section.leaf}
            to={section.to}
            className={cn(
              'rounded-md px-2.5 py-1.5 text-[13px] transition-colors',
              leaf === section.leaf
                ? 'bg-plum-selected text-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-foreground',
            )}
          >
            {section.label}
          </Link>
        ))}
      </nav>

      <Outlet />
    </>
  )
}
